export { PLUGIN_KEY, PLUGIN_PRIORITY, Formulas } from "./formulas.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/formulas/index.mjs
// module id = 1422
// module chunks = 1